import { useRouteContext } from "@tanstack/react-router";

export type RecordPermissions = {
  viewPermissions: Record<string, boolean>;
  editPermissions: Record<string, boolean>;
  canViewRecord: (recordType: string) => boolean;
  canEditRecord: (recordType: string) => boolean;
};

export function useRecordPermissions(): RecordPermissions {
  const leaContext = useRouteContext({ from: "/$leaid" });

  const viewPermissions: Record<string, boolean> = {
    CHLD: !!leaContext.hasRole("CHLDView"),
    ENRL: !!leaContext.hasRole("ENRLView"),
    CLEN: !!leaContext.hasRole("CLENView"),
    FAMI: !!leaContext.hasRole("FAMIView"),
    LANG: !!leaContext.hasRole("LANGView"),
    SLNG: !!leaContext.hasRole("SLNGView"),
    STFF: !!leaContext.hasRole("STFFView"),
    SASS: !!leaContext.hasRole("SASSView"),
    SCLR: !!leaContext.hasRole("SCLRView"),
    CLRM: !!leaContext.hasRole("CLRMView"),
    ATTN: !!leaContext.hasRole("ATTNView"),
  };

  const editPermissions: Record<string, boolean> = {
    CHLD: !!leaContext.hasRole("CHLDEdit"),
    ENRL: !!leaContext.hasRole("ENRLEdit"),
    CLEN: !!leaContext.hasRole("CLENEdit"),
    FAMI: !!leaContext.hasRole("FAMIEdit"),
    LANG: !!leaContext.hasRole("LANGEdit"),
    SLNG: !!leaContext.hasRole("SLNGEdit"),
    STFF: !!leaContext.hasRole("STFFEdit"),
    SASS: !!leaContext.hasRole("SASSEdit"),
    SCLR: !!leaContext.hasRole("SCLREdit"),
    CLRM: !!leaContext.hasRole("CLRMEdit"),
    ATTN: !!leaContext.hasRole("ATTNEdit"),
  };

  const canViewRecord = (recordType: string): boolean => {
    return viewPermissions[recordType] ?? false;
  };

  const canEditRecord = (recordType: string): boolean => {
    return editPermissions[recordType] ?? false;
  };

  return {
    viewPermissions,
    editPermissions,
    canViewRecord,
    canEditRecord,
  };
}
